import * as React from 'react'

import apis from '@app/api/api'

import ScreenContainer from '@components/screenContainer/screenContainer'
import OrphanFocusMenu from '@components/menu/orphanFocusMenu'
import OrphanFocusMap from '@components/map/orphanFocusMap'

interface Props {
  navigation: Navigation
  orphanId: string
}

const OrphanFocus = ({ navigation, orphanId }: Props) => {
  const [orphan, setOrphan] = React.useState<OrphanDeclarationDetails | undefined>(undefined)
  const [steps, setSteps] = React.useState<BusinessStep[]>([])
  const [screenStatus, setScreenStatus] = React.useState<ScreenStatus>('loading')

  React.useEffect(() => {
    Promise.all([apis.orphan.get(orphanId), apis.step.list()])
      .then(([b, s]) => {
        setOrphan(b)
        setSteps(s)
        setScreenStatus('fetched')
      })
      .catch(() => {
        setScreenStatus('error')
      })
  }, [])

  return (
    <ScreenContainer
      menu={<OrphanFocusMenu navigation={navigation} screenStatus={screenStatus} orphan={orphan} steps={steps} />}
      content={<OrphanFocusMap navigation={navigation} screenStatus={screenStatus} orphan={orphan} />}
    />
  )
}

export default OrphanFocus
